const state = {
  returnOrderData: null
}

const mutations = {
  SET_FORM: (state, returnOrderData) => {
    state.returnOrderData = returnOrderData
  }
}

const actions = {
  setForm({ commit }, data) {
    console.log(data)
    commit('SET_FORM', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
